<template>
  
        <div class="slider" >
            <div v-if="nav=='MYPARTIE'">
                <div class="sheader">Le concours est en cours</div>
                
                <div  class="buttonsNav">
                    <div class="buttonsFootLeft" >
                    <s-button theme="is-primary"  :label="'Partie ' + (parseInt(indexPartie))"
                            @onclick="prec"
                            icon="arrow-left"
                            :disabled="(indexPartie) == 0"
                            v-if="(indexPartie) > 0" />
                    </div>
                    <div class="buttonsFootRight"    >
                    <s-button theme="is-primary" 
                        :label="'Partie ' + (parseInt(indexPartie)+2)" @onclick="next"
                        afterIcon="arrow-right"
                        :disabled="parseInt(indexPartie)+1 == this.parties.length" />
                    </div>
                            
                </div>
            </div>
            <tournoi-resultat-vue
                v-if="nav=='resultat'  && tournoi!=null"
                @viewGame=""
                :tournoi="tournoi"
                :club="club"
                @back=""
                 role="player"
                @listJoueurs = ""
                @nav=""
                :key="tournoi.id"
                :menu="false"
            >

            </tournoi-resultat-vue>

            <tournoi-resultat-pool-vue
                v-if="nav=='resultatPool'  && tournoi!=null"
                :tournoi="tournoi"
                :club="club"
                role="player"
                :key="tournoi.id"
                :menu="false"
            />
            <tournoi-list-joueurs-vue
                v-if="nav=='list'  && tournoi!=null"
                :tournoi="tournoi"
                :club="club"
                role="player"
                :key="tournoi.id"
                :menu="false"
            />
            <div class="g_menuMobile">
                <table class="g_menuFooter">
                    <tr>
                        <td colspan="4" class="g_headerFooter">
                            <div v-if="partie">{{titlePartie}} :
                            <span v-if="partie.state=='INPROGRESS'">en cours </span>
                            <span v-if="partie.state=='FINISH'">terminé  </span>
                            <span v-if="partie.state=='WAITING'">en attente</span>
                            
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td >
                            <s-button icon="gamepad" theme="is-primary" label="Ma partie"
                                @onclick="nav='MYPARTIE'"
                                mode="V"
                                />
                        </td>
                        <td >
                            <s-button icon="users" theme="is-info" label="Joueurs"
                                @onclick="nav='list'"
                                mode="V"
                                />
                        </td>
                        <td >
                            <s-button icon="medal" theme="is-success " label="Classement"
                                @onclick="nav='resultat'"
                                mode="V"
                                />
                            
                        </td>
                        
                       
                    </tr>
                </table>
            </div>
           
           <hooper style="height: 450px; " ref="slideEquipe" 
                    :mouseDrag="false" :wheelControl="false" :touchDrag="true"
                    @slide="updateCarousel" v-if="nav=='MYPARTIE'">
                <slide v-for="indexPartie2 in this.parties.length" >
                    <div>
                     
                    <my-partie
                        :indexPartie = "indexPartie2-1"
                        :club = "club"
                        :tournoi = "tournoi"
                        :numeroJoueur="numeroJoueur"
                        :joueur="joueur"
                        :ref="'Partie'+(indexPartie2-1)"
                        />
                    </div>
                    
                </slide>

            </hooper>
          
        </div>
        
    
</template>
<style  scoped> 
 @media screen and (min-width: 420px) {  
         .buttonsNav {
             width:100%;
             height: 50px;
         }
     }
    @media screen and (max-width: 420px) {  
        .buttonsNav {
            width: 100%;
            height: 50px;
            position: fixed;
            bottom: 100px;
           
        }
    }
    .slider {
        height: 100%;
        position: relative;
        
    }
    .sheader {
        font-size: 18px;
        color: black;
        font-weight: bolder;
        font-style: italic;
    }
     .buttonsFootRight {
        float: right;
        margin-right: 20px;
    }
     .buttonsFootLeft {
        margin-left: 20px;
        float: left;
    }
    
</style>
<script>

import { Hooper, Slide} from 'hooper';
import myPartie from '@/views/myTournoi/myPartie.vue';
import TournoiResultatVue         from '@/views/tournoi/resultat.vue'
import TournoiResultatPoolVue         from '@/views/tournoi/resultatPool.vue'
import TournoiListJoueursVue           from '@/views/tournoi/listJoueurs.vue'
import firebase_api from '@/firebase/firebase_api';
export default {
     props: ["joueur", "club", "tournoi","numeroJoueur"],
     components: {
            Hooper, Slide,
            myPartie,
            TournoiResultatVue,
            TournoiResultatPoolVue,
            TournoiListJoueursVue
     },
     data() {
         return {
            indexPartie: 0,
            nav: 'MYPARTIE',
            parties: []
         }
     },
     watch: {
         
         indexPartie(newValue, value) {
             if (typeof(this.$refs['Partie'+newValue])!="undefined") {
                if (this.$refs['Partie'+newValue][0]!="undefined") {
                    this.$refs['Partie'+newValue][0].initEquipe();
                }
             }
         }
     },
     computed: {
         partie: {
             get() {
                 return this.parties[this.indexPartie]
             }
         },
         titlePartie: {
             get() {
                 if (this.tournoi.options.competition == 3) {
                    if (this.indexPartie==0)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==1)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==2)
                        return "Barrage"
                    if (this.indexPartie>2)
                        return "Eliminatoire " + (this.indexPartie+1)
                 }
                 else 
                    return "Partie " + (this.indexPartie+1)
             }
         }
     },
     methods: {
         goConcours() {
            
         },
         historique() {
            var indexPartie = this.indexPartie + 1;
            var ref = 'Partie'+indexPartie;
            this.$refs[ref][0].openHistoriqueMenes();
            
         },
         savePartie() {
            var indexPartie = this.indexPartie + 1;
            var ref = 'Partie'+indexPartie;
            this.$refs[ref][0].save();
         },
          updateCarousel(payload) {
             this.indexPartie = payload.currentSlide;
             this.$refs.slideEquipe.slideTo(this.indexPartie);
            
        },
         next() {
            this.indexPartie++;
            this.$refs.slideEquipe.slideTo(this.indexPartie);
        },
        prec() {
            this.indexPartie--;
            this.$refs.slideEquipe.slideTo(this.indexPartie);
        },
        
     },
     mounted() {
       this.$bind("parties",firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("tournois").doc(this.tournoi.id)
                        .collection("parties"))
     }
}
</script>